"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ioTsNewtypeInterpreter = void 0;
var utils_1 = require("@morphic-ts/common/lib/utils");
var fp_ts_1 = require("fp-ts");
var function_1 = require("fp-ts/lib/function");
var io_ts_1 = require("io-ts");
var config_1 = require("../config");
var hkt_1 = require("../hkt");
var coerce = function (e) { return e; };
/**
 *  @since 0.0.1
 */
exports.ioTsNewtypeInterpreter = utils_1.memo(function () { return ({
    _F: hkt_1.IoTsURI,
    newtype: function () { return function (a, config) { return function (env) {
        return function_1.pipe(a(env).type, function (type) { return new hkt_1.IOTSType(config_1.iotsApplyConfig(config)(coerce(type), env, { type: type })); });
    }; }; },
    newtypeIso: function (iso, a, name, config) { return function (env) {
        return function_1.pipe(a(env).type, function (type) {
            var is = function (v) { return type.is(v); };
            return new hkt_1.IOTSType(config_1.iotsApplyConfig(config)(new io_ts_1.Type(name, is, function (i, c) { return function_1.pipe(type.validate(i, c), fp_ts_1.either.map(iso.get)); }, function (v) { return type.encode(iso.reverseGet(v)); }), env, { type: type }));
        });
    }; },
    newtypePrism: function (prism, a, name, config) { return function (env) {
        return function_1.pipe(a(env).type, function (type) {
            var is = function (v) { return type.is(v); };
            return new hkt_1.IOTSType(config_1.iotsApplyConfig(config)(new io_ts_1.Type(name, is, function (i, c) {
                return function_1.pipe(type.validate(i, c), fp_ts_1.either.chain(function (v) {
                    var x = prism.getOption(v);
                    return x._tag === 'None'
                        ? io_ts_1.failure(i, c, "newtype doesn't satisfy prism conditions")
                        : io_ts_1.success(x.value);
                }));
            }, function (v) { return type.encode(prism.reverseGet(v)); }), env, { type: type }));
        });
    }; }
}); });
